import lyngonaut from "../../assets/lyngonaut.png";
import vinyl from "../../assets/loader.gif";

const NoTrack = () => {
  return (
    <div className="row">
      <div className="col pt-3 text-center">
        <h1 className="text-warning">No Track Playing 📻</h1>
        <p className="text-light mt-4">
          We couldn't find any track playing at the moment. Please play a track
          in Spotify and come back.
        </p>
      </div>
    </div>
  );
};

const NoLyrics = () => {
  return (
    <div className="row">
      <div className="col pt-3 text-center">
        <h1 className="text-warning">Lyrics Not Found ☹️</h1>
        <p className="text-light mt-4">
          Unfortunately we couldn't find the lyrics for this track. Please try a
          different one ...
        </p>
      </div>
    </div>
  );
};

const Lyngonaut = () => {
  return (
    <div className="row">
      <div className="col-12 d-flex flex-column align-items-center achievment px-4">
        <img width={128} src={lyngonaut} alt="Lyngonaut" />
        <h4 className="text-warning mt-3 mb-4">Lyngonaut 🚀</h4>
        <p className="text-light w-sm-100 w-md-50 text-center">
          Conagrats! You seem to be the first one to request this song in this
          language 🔥
          <br />
          <br />
          Please hang on for a while until we find the lyrics and prepare the
          translation for you. This might take a moment...
        </p>
        <img width={64} className="mt-2" src={vinyl} alt="Loading..." />
      </div>
    </div>
  );
};

export { NoTrack, NoLyrics, Lyngonaut };
